import PageHero from "../components/PageHero";
import ServicesGrid from "../components/ServicesGrid";
import CtaBanner from "../components/CtaBanner";
import { INTERIOR_IMAGES } from "../data/site";
import { useLang } from "../i18n/LanguageContext";

export default function Servizi() {
  const { t } = useLang();

  return (
    <div data-testid="servizi-page">
      <PageHero
        overline={t.servicesPage.overline}
        title={t.servicesPage.title}
        desc={t.servicesPage.desc}
        images={[INTERIOR_IMAGES.bathroom, INTERIOR_IMAGES.living]}
        imageAlt={t.servicesPage.imageAlt}
      />
      <section className="bg-white py-20 sm:py-24" data-testid="services-section">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <ServicesGrid mode="modal" />
        </div>
      </section>
      <CtaBanner />
    </div>
  );
}
